import React from 'react';
import { Box } from '@mui/material';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { AnalyticsDataPoint } from '../types';

type ChartDataPoint = AnalyticsDataPoint & {
  displayDate: string;
};

type VisitorChartProps = {
  data: AnalyticsDataPoint[];
  formatDate: (dateString: string) => string;
};

export const VisitorChart = ({ data, formatDate }: VisitorChartProps) => {
  const chartData: ChartDataPoint[] = data.map(d => ({
    ...d,
    displayDate: formatDate(d.date),
  }));

  return (
    <Box className="chart-container">
      <ResponsiveContainer width="100%" height={400}>
        <LineChart
          data={chartData}
          margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="displayDate"
            tick={{ fontSize: 12 }}
            interval={Math.floor(data.length / 10)}
          />
          <YAxis />
          <Tooltip
            animationDuration={0}
            formatter={(value: string | number | Array<string | number> | undefined, name: string | undefined) => {
              const labels: { [key: string]: string } = {
                totalCount: 'Total',
                loggedInCount: 'Logged In',
                loggedOutCount: 'Logged Out',
              };
              return [value, labels[name || ''] || name || ''];
            }}
            labelFormatter={(label) => {
              const point = chartData.find(d => d.displayDate === label);
              return point ? point.date : label;
            }}
            itemSorter={(item) => -(item.value as number)}
          />
          <Legend
            formatter={(value: string) => {
              const labels: { [key: string]: string } = {
                totalCount: 'Total Visitors',
                loggedInCount: 'Logged In Users',
                loggedOutCount: 'Logged Out Users',
              };
              return labels[value] || value;
            }}
          />
          <Line
            type="monotone"
            dataKey="totalCount"
            stroke="#8884d8"
            strokeWidth={2}
            name="totalCount"
          />
          <Line
            type="monotone"
            dataKey="loggedInCount"
            stroke="#82ca9d"
            strokeWidth={2}
            name="loggedInCount"
          />
          <Line
            type="monotone"
            dataKey="loggedOutCount"
            stroke="#ffc658"
            strokeWidth={2}
            name="loggedOutCount"
          />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
};
